import { IconInfoBold } from '@croquiscom-pvt/zds';

import { Typography } from '@common/styles';

import { ActualSize } from '../components/actual-size/ActualSize';
import { Measurement } from '../components/actual-size/Measurement';
import { SizeInfoList } from '../components/actual-size/SizeInfoList';
import { SizeMeasurementsTable } from '../components/actual-size/SizeMeasurementsTable';
import { useLegacyActualSizeService } from '../services/useLegacyActualSizeService';

export const LegacyActualSizeContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { visible, itemList, catalogProductId, overflowRef, isOverflowing, sizeTable } = useLegacyActualSizeService();

  if (visible) {
    return (
      <ActualSize>
        <SizeInfoList
          catalogProductId={catalogProductId}
          itemList={itemList}
          renderItem={(item, index) => {
            return (
              <Measurement key={item.imageUrl + index}>
                {item.imageUrl && (
                  <Measurement.ImageArea>
                    <Measurement.Image src={item.imageUrl} alt='' />
                  </Measurement.ImageArea>
                )}
                {isOverflowing && (
                  <Measurement.GuideText>
                    <p className={Typography.CAPTION_12_REGULAR}>좌우로 밀어보세요</p>
                    <Measurement.SwiperIcon />
                  </Measurement.GuideText>
                )}
                {Boolean(item.valueList.length) && (
                  <Measurement.Table ref={overflowRef}>
                    <SizeMeasurementsTable
                      valueList={item.valueList}
                      fixedColumnWidth={sizeTable.fixedColumnWidth}
                      columnMinWidth={sizeTable.columnMinWidth}
                      handleSetColRef={sizeTable.handleSetColRef}
                    />
                  </Measurement.Table>
                )}
                {Boolean(item.description.length) && (
                  <Measurement.Description>
                    <IconInfoBold color='gray400' size={16} />
                    <ul>
                      {item.description.map((description) => (
                        <li key={description}>
                          <ActualSize.Caution className={Typography.CAPTION_12_REGULAR}>
                            {description}
                          </ActualSize.Caution>
                        </li>
                      ))}
                    </ul>
                  </Measurement.Description>
                )}
              </Measurement>
            );
          }}
        />
      </ActualSize>
    );
  }

  return null;
};
